import { render, staticRenderFns } from "./newClientQuickModal.vue?vue&type=template&id=1922bcfc&"
import script from "./newClientQuickModal.vue?vue&type=script&lang=js&"
export * from "./newClientQuickModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports